export default class BackgroundCategoryTranslationsRequest {
	Id?: string = null;
	LangCode: string = '';
	Name: string = '';
	constructor(obj?: Partial<BackgroundCategoryTranslationsRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
